export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const ADD_FILTER = 'ADD_FILTER'
export const REMOVE_FILTER = 'REMOVE_FILTER'
export const STORE_DATA_FROM_API = 'STORE_DATA_FROM_API'
export const INCREASE_GPA = 'INCREASE_GPA'
export const DECREASE_GPA = 'DECREASE_GPA'
export const SORT_TABLE = 'SORT_TABLE'
export const FILTER_NAME_ADD = 'FILTER_NAME_ADD'
export const FILTER_NAME_DEL = 'FILTER_NAME_DEL'
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const TOGGLE_THEME = 'TOGGLE_THEME'
